import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useState } from 'react';
import { apiGeneralUploadImage } from '../../api/universal';
export var useUploadFile = function useUploadFile() {
  var _useState = useState(false),
      fileLoading = _useState[0],
      setFileLoading = _useState[1];

  var requestUploadFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, config) {
      var _yield$apiGeneralUplo, _yield$apiGeneralUplo2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setFileLoading(true);
              _context.next = 3;
              return apiGeneralUploadImage({
                file: file,
                is_logo: !!(config !== null && config !== void 0 && config.isLogo),
                img_type: config === null || config === void 0 ? void 0 : config.imgType
              });

            case 3:
              _yield$apiGeneralUplo = _context.sent;
              _yield$apiGeneralUplo2 = _slicedToArray(_yield$apiGeneralUplo, 1);
              res = _yield$apiGeneralUplo2[0];
              setFileLoading(false);
              return _context.abrupt("return", res);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestUploadFile(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    fileLoading: fileLoading,
    requestUploadFile: requestUploadFile
  };
};